module.exports = ".inspection-only ul > li {\n  width: 18% !important; }\n  .inspection-only ul > li:first-child {\n    width: 3% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/incidents/incidents.component.scss
// module id = ./src/app/incidents/incidents.component.scss
// module chunks = main